"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

var _styledComponents = require("styled-components");

var _styledComponents2 = _interopRequireDefault(_styledComponents);

var _Box = require("../Box");

var _Box2 = _interopRequireDefault(_Box);

var _Flex = require("../Flex");

var _Flex2 = _interopRequireDefault(_Flex);

var _Text = require("../Text");

var _Text2 = _interopRequireDefault(_Text);

var _Spinner = require("../Spinner");

var _Spinner2 = _interopRequireDefault(_Spinner);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

const List = () => _react2.default.createElement(_Box2.default, null);

List.Header = (0, _styledComponents2.default)(_Box2.default).withConfig({
  displayName: "List__Header",
  componentId: "o2p8az-0"
})([""]);

List.Header.defaultProps = {
  p: 3,
  border: 1,
  borderRadius: "4px 4px 0 0",
  borderColor: "palette.ink.300"
};

const ListItem = (0, _styledComponents2.default)(_Box2.default).withConfig({
  displayName: "List__ListItem",
  componentId: "o2p8az-1"
})(["", ""], p => p.disabled ? `opacity:0.5; pointer-events: none;` : null);

const ListItemWrapper = (0, _styledComponents2.default)(_Box2.default).withConfig({
  displayName: "List__ListItemWrapper",
  componentId: "o2p8az-2"
})(["cursor:pointer;&:hover{background-color:", ";}&:last-of-type{border-radius:0 0 4px 4px;}", ""], p => p.theme.colors.palette.ink["000"], p => p.disabled ? "pointer-events: none;" : null);

List.Item = (_ref) => {
  let { children, disabled } = _ref,
      props = _objectWithoutProperties(_ref, ["children", "disabled"]);

  return _react2.default.createElement(
    ListItemWrapper,
    _extends({}, props, { disabled: disabled }),
    _react2.default.createElement(
      ListItem,
      { disabled: disabled },
      children
    )
  );
};

ListItemWrapper.defaultProps = {
  p: 3,
  border: 1,
  borderTop: 0,
  borderColor: "palette.ink.300"
};

List.Empty = (_ref2) => {
  let { children } = _ref2,
      props = _objectWithoutProperties(_ref2, ["children"]);

  return _react2.default.createElement(
    _Box2.default,
    props,
    _react2.default.createElement(
      _Flex2.default,
      {
        alignItems: "center",
        justifyContent: "center",
        bg: "palette.ink.000",
        height: 64
      },
      _react2.default.createElement(
        _Text2.default,
        { fontSize: 1, color: "palette.ink.700" },
        children
      )
    )
  );
};

List.Empty.defaultProps = {
  p: 3,
  border: 1,
  borderTop: 0,
  borderColor: "palette.ink.300",
  borderRadius: "0 0 4px 4px"
};

List.Loading = (_ref3) => {
  let props = _objectWithoutProperties(_ref3, []);

  return _react2.default.createElement(
    _Flex2.default,
    props,
    _react2.default.createElement(_Spinner2.default, { variant: props.size ? props.size : "medium" })
  );
};

List.Loading.defaultProps = {
  p: 4,
  border: 1,
  borderTop: 0,
  borderColor: "palette.ink.300",
  borderRadius: "0 0 4px 4px",
  justifyContent: "center",
  alignItems: "center"
};

exports.default = List;